export default "__VITE_ASSET__BShR0DE1__"